<template>
    <div class="my-5 border-b border-t border-grey-light scrollable-div">
        <!-- Modal -->
        <div id="NewView" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ (editableProjectView && editableProjectView.id) ? 'Edit' : 'New' }} Lists</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <input v-model="new_view" type="text" name="name" id="name"
                               class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full">
                        <div class="text-red text-xs">{{
                                showError
                            }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button  type="button" id="save-proposal-generator" name="save-proposal-generator"
                                 @click.prevent="saveEditView"
                                 class="btn btn-outline-primary rounded-full">
                            {{ (editableProjectView && editableProjectView.id) ? 'Edit' : 'Save' }} Lists
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap container bg-grey-lightest justify-between items-start shadow-md rounded">
            <div class="row w-full justify-end mt-2">
                <button class="btn btn-primary mr-2" @click.prevent="openNewViewModel">{{ (editableProjectView && editableProjectView.id) ? 'Edit' : 'Save' }} Lists</button>
                <button class="btn btn-danger mr-2" @click.prevent="clear">Clear</button>
                <button class="btn btn-primary" @click.prevent="execute">Apply</button>
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Project Information
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            ID
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.project_id">
                        </div>
                    </div>

                    <div v-if="userLegacy" class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Legacy ID
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.legacy_id">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Project Name
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.project_name">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Address
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.address">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            City
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.city">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            State
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.state">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Zip
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.zip">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Name
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.contact_name">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Email
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.contact_email">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Phone
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_phone">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Cell
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_cell">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Fax
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_fax">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex w-full w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Miscellaneous Information
                </h4>
                <div class="col-md-12 flex flex-wrap miscellaneous-info">
                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('sales-status')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'sales-status')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.sales_statuses"
                                        id="sales_status_id"
                                        placeholder="Select sales status"
                                        :options="selects.sales_status"
                                        :multiple="true"
                                        trackBy="id"
                                        label="short_description"
                                        :taggable="false"
                                        :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('marketing-status')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'marketing-status')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.marketing_statuses"
                                         id="marketing_status_id"
                                         placeholder="Select marketing status"
                                         :options="selects.marketing_status"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('pre-bid')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'pre-bid')}}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.pre_bid.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.pre_bid.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('bid-date')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'bid-date')}}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.bid_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.bid_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('lead-source')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'lead-source')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.lead_froms"
                                         id="lead_from_id"
                                         placeholder="Select lead from"
                                         :options="selects.lead_from"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('estimator')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'estimator')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.estimators"
                                         id="estimator_id"
                                         placeholder="Select estimator"
                                         :options="selects.users"
                                         :multiple="true"
                                         trackBy="id"
                                         label="name"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('account-manager')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'account-manager')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.account_managers"
                                         id="account_manager_id"
                                         placeholder="Select account manager"
                                         :options="selects.users"
                                         :multiple="true"
                                         trackBy="id"
                                         label="name"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('take-off-person')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'take-off-person')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.take_off_persons"
                                         id="take_off_person"
                                         placeholder="Select take off person"
                                         :options="selects.users"
                                         :multiple="true"
                                         trackBy="id"
                                         label="name"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('products-and-services')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'products-and-services')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.products_and_services"
                                         id="products_and_services_id"
                                         placeholder="Select product and services"
                                         :options="selects.products_and_services"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('client-profile')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'client-profile')}}
                        </div>
                        <div class="col-md-12">

                            <multiselect v-model="advanced_filter.client_profiles"
                                         id="client_profile_id"
                                         placeholder="Select client profiles"
                                         :options="selects.client_profile"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('contract-type')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'contract-type')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.contract_types"
                                         id="contract_type_id"
                                         placeholder="Select contract types"
                                         :options="selects.contract_type"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.fieldLabels.hasOwnProperty('office')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(fieldLabels, 'office')}}
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.offices"
                                         id="office_id"
                                         placeholder="Select offices"
                                         :options="selects.office"
                                         :multiple="true"
                                         trackBy="id"
                                         label="short_description"
                                         :taggable="false"
                                         :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>
                </div>

                <advanced-search-custom-fields ref="customFields"
                                               :local-storage-values="customFieldsLocalStorage"
                                               :project-custom-fields="this.projectCustomFields" :masks="masks"></advanced-search-custom-fields>

            </div>

            <div v-if="prequalification" class="row flex w-full w-full lg:w-1/2 mt-3">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2 ">
                    Prequalifications
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Relate & Connect
                        </div>
                        <div class="col-md-12">
                            <select name="relate_and_connect" id="relate_and_connect"
                                    v-model="advanced_filter.relate_and_connect_id"
                                    class="form-control field-custom-height">
                                <option v-for="item in selects.relate_and_connect" :value="item.id">{{
                                    item.short_description }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Rules of Engagement
                        </div>
                        <div class="col-md-12">
                            <select name="rules_of_engagement" id="rules_of_engagement"
                                    v-model="advanced_filter.rules_of_engagement_id"
                                    class="form-control field-custom-height">
                                <option v-for="item in selects.rules_of_engagement" :value="item.id">{{
                                    item.short_description }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Find Problems
                        </div>
                        <div class="col-md-12">
                            <select name="find_problems" id="find_problems"
                                    v-model="advanced_filter.find_problems_id"
                                    class="form-control field-custom-height">
                                <option v-for="item in selects.find_problems" :value="item.id">{{ item.short_description
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Money Steps
                        </div>
                        <div class="col-md-12">
                            <select name="money_step" id="money_step"
                                    v-model="advanced_filter.money_step_id"
                                    class="form-control field-custom-height">
                                <option v-for="item in selects.money_step" :value="item.id">{{ item.short_description }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Decision Process
                        </div>
                        <div class="col-md-12">
                            <select name="decision_process" id="decision_process"
                                    v-model="advanced_filter.decision_process_id"
                                    class="form-control field-custom-height">
                                <option v-for="item in selects.decision_process" :value="item.id">{{
                                    item.short_description }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row flex w-full w-full lg:w-1/2 mt-3">
            </div>

            <div class="row flex w-full w-full lg:w-1/2 mt-3">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Record Details
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('base-bid')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'base-bid') }}
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.base_bid" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="team.project_change_orders && team.has_pipeline_graph && this.recordDetailFieldLabels.hasOwnProperty('final-base-bid')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'final-base-bid') }}
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.base_bid_total" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('contract-amount')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'contract-amount') }}
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.contract_amount" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="team.project_change_orders && team.has_sum_contract_amount && this.recordDetailFieldLabels.hasOwnProperty('final-contract-amount')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'final-contract-amount') }}
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.contract_amount_total" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="team.has_probability_access && this.recordDetailFieldLabels.hasOwnProperty('estimated-contract-date')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'estimated-contract-date') }}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.estimated_contract_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.estimated_contract_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('contract-date') && advanced_filter.contract_date">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'contract-date') }}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.contract_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.contract_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('login-date')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'login-date') }}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.login_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.login_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('gross-margin')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'gross-margin') }} %
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.gross_margin" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('labor-hours')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'labor-hours') }}
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.labor_hours" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2" v-if="this.recordDetailFieldLabels.hasOwnProperty('dead-date')">
                        <div class="col-md-12 text-md">
                            {{ getFieldLabel(recordDetailFieldLabels, 'dead-date') }}
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.dead_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.dead_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <advanced-search-record-detail-custom-fields
                        ref="RecordDetailCustomFields" :masks="masks"
                        :custom-fields="rDCustomFields">
                    </advanced-search-record-detail-custom-fields>
                </div>
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0 mb-4">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Companies & Contacts
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Companies
                        </div>
                        <div class="col-md-12">
                            <multiselect
                                v-model="advanced_filter.companies_id"
                                :options="companies"
                                label="name"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                @search-change="asyncFind"
                                :loading="isLoading"
                                track-by="id"
                               @input="selectedCompanies"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Contacts
                            <span v-if="contacts_data_loading" class="text-1xl text-grey-darkest text-center mt-32 ml-1">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="col-md-12">
                            <multiselect
                                v-model="advanced_filter.contact_ids"
                                :options="contacts"
                                label="name"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                track-by="id"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex w-full w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Sales Activities



                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <template v-if="Object.keys(advanced_filter.sales_behavior).length" v-for="(salesBehavior) in salesBehaviors">
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                {{ salesBehavior.name }}
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.sales_behavior[salesBehavior.key].start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.sales_behavior[salesBehavior.key].end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Comments
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Comments
                        </div>
                        <div class="col-md-12">
                            <b-form-textarea
                                id="textarea"
                                v-model="advanced_filter.comment"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="team.project_change_orders" class="row flex w-full w-full lg:w-1/2 mb-5">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Change Orders
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Change Order Name
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.change_order_name">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Sales Status
                        </div>
                        <div class="col-md-12">
                            <multiselect v-model="advanced_filter.change_order_sales_statuses"
                                        id="sales_status_id"
                                        placeholder="Select sales status"
                                        :options="selects.sales_status"
                                        :multiple="true"
                                        trackBy="id"
                                        label="short_description"
                                        :taggable="false"
                                        :close-on-select="false"
                            >
                            </multiselect>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Base Bid
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.change_order_base_bid" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contract Amount
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.change_order_contract_amount" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Bid Date
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.change_order_bid_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.change_order_bid_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contract Date
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.change_order_contract_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.change_order_contract_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Gross Margin %
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control field-custom-height" v-model="advanced_filter.change_order_gross_margin" min="0"
                                   step="0.01">
                        </div>
                    </div>



                    <div class="form-group w-full md:w-1/2" v-for="(field, index) in selects.change_order_custom_fields" v-if="field.enabled">
                        <div class="col-md-12 text-md">
                            {{ field.label_value }}
                        </div>
                        <div v-if="field.type == 2" class="col-md-12">
                            <input type="text" class="form-control field-custom-height" v-model="advanced_filter.change_order_custom_fields[field.id]">
                        </div>
                        <div v-else-if="field.type === 4" class="col-md-12">
                            <datetime type="date"
                                        v-model="advanced_filter.change_order_custom_fields[field.id]"
                                        :use-utc="true"
                                        :format="masks.date_mask"
                                        class="form-control field-custom-height"/>
                        </div>
                        <div v-else-if="field.type == 1 || field.type == 3" class="col-md-12">
                            <multiselect v-model="advanced_filter.change_order_custom_fields[field.id]"
                                :placeholder="'Select ' + field.name"
                                :options="field.options"
                                :multiple="true"
                                track-by="id"
                                label="name"
                                value="id"
                                :taggable="false"
                                :close-on-select="false">
                            </multiselect>
                        </div>
                    </div>





                </div>
            </div>
            <div v-else class="row flex w-full w-full lg:w-1/2 mb-5">
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0">
                <div class="col-md-3 mb-3 pb-2 mt-1">
                    <h4>Attachments</h4>
                </div>
                <div class="col-md-9 mb-3 pb-2">
                    <b-form-checkbox v-model="advanced_filter.attachment"></b-form-checkbox><span class="ml-1"> Include only projects with documents</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import AdvancedSearchRecordDetailCustomFields from "./custom-fields/advanced-search-record-detail-custom-fields.vue";

export default {
    components: {
        AdvancedSearchRecordDetailCustomFields,
        Datepicker,
        Multiselect
    },
    props: ['userLegacy', 'advancedSearchViewFilterProjectData', 'advancedSearchViewFilterProjectCustomFields','masks', 'selects','fieldLabels', 'editableProjectView','team', 'salesBehaviors', 'prequalification', 'recordDetailFieldLabels',
    'advancedSearchViewFilterRecordDetailCustomFields'],
    watch: {
      	advancedSearchViewFilterProjectData:{
            handler(newVal) {
                if (Object.keys(newVal).length === 0) {
                    this.resetAdvancedFilter();
                } else {
                    Object.assign(this.advanced_filter, newVal);
                    this.updateAdvancedFilter(this.salesBehaviors);
                }
            },
            immediate: true,
            deep:      true
        },
        advancedSearchViewFilterProjectCustomFields: function(newVal, oldVal) {
            this.projectCustomFields = newVal;
        },
        advancedSearchViewFilterRecordDetailCustomFields: function(newVal, oldVal) {
            this.rDCustomFields = newVal;
        },
        selects: function(val){
            console.log("watcher for selects", val)
            this.fetchCompanies();
        },
        salesBehaviors: {
            handler(newVal) {
                this.updateAdvancedFilter(newVal);
            },
            immediate: true
        }
    },
    data() {
        return {
            isLoading: false,
            advanced_filter: {
                advanced: true,
                project_id: '',
                legacy_id: '',
                project_name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_cell: '',
                contact_fax: '',
                sales_status_id: 0,
                marketing_status_id: 0,
                pre_bid: {start: '', end: ''},
                bid_date: {start: '', end: ''},
                lead_from_id: 0,
                estimator_id: 0,
                account_manager_id: 0,
                take_off_person_id: 0,
                products_and_services_id: 0,
                client_profile_id: 0,
                contract_type_id: 0,
                office_id: 0,
                relate_and_connect_id: 0,
                rules_of_engagement_id: 0,
                find_problems_id: 0,
                money_step_id: 0,
                decision_process_id: 0,
                base_bid: '',
                base_bid_total: '',
                contract_amount: '',
                contract_amount_total: '',
                estimated_contract_date:{start:'',end:''},
                contract_date: {start: '', end: ''},
                login_date: {start: '', end: ''},
                gross_margin: '',
                labor_hours: '',
                dead_date: {start: '', end: ''},
                companies_id: [],
                contact_ids: [],
                comment: '',
                sales_statuses: null,
                marketing_statuses: null,
                lead_froms: null,
                estimators: null,
                account_managers: null,
                take_off_persons: null,
                products_and_services: null,
                client_profiles: null,
                contract_types: null,
                offices: null,
                change_order_name: '',
                change_order_sales_statuses: null,
                change_order_base_bid: '',
                change_order_contract_amount: '',
                change_order_bid_date: {start: '', end: ''},
                change_order_contract_date: {start: '', end: ''},
                change_order_gross_margin: '',
                attachment: '',
                change_order_custom_fields: {},
                sales_behavior: {}
            },
            customFieldsLocalStorage: null,
            companies: [],
            contacts: [],
            companiesSelected: [],
            new_view:'',
            showError:'',
            projectCustomFields: {},
            rDCustomFields: {},
            contacts_data_loading: false,
        }
    },

    created() {
        console.log('selects',this.selects)
        // this.fetchCodes();
        // this.fetchCompanies();
    },

    methods: {
        execute() {
            const customFields = this.$refs.customFields.getFields();
            const recordDetailCustomFields = this.$refs.RecordDetailCustomFields.getFields();
            localStorage.setItem('last_search', JSON.stringify({...this.advanced_filter, custom_fields: customFields, record_detail_custom_fields: recordDetailCustomFields}));
            this.$emit('execute', {...this.advanced_filter, custom_fields: customFields, record_detail_custom_fields: recordDetailCustomFields});
            this.checkChangeOrder();
        },

        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                // for (var item in data) {
                //     if (Object.prototype.hasOwnProperty.call(data, item)) {
                //         data[item].unshift({id: 0, name: 'Select', code: 'Select', short_description: 'Select'})
                //     }
                // }
                // this.selects = data;
                this.selects.decision_process = data.decision_process ?? [];
                this.selects.find_problems = data.find_problems ?? [];
                this.selects.money_step = data.money_step ?? [];
                this.selects.pm_users = data.pm_users ?? [];
                this.selects.relate_and_connect = data.relate_and_connect ?? [];
                this.selects.rules_of_engagement = data.rules_of_engagement ?? [];
                this.selects.sales_status = data.sales_status.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.marketing_status = data.marketing_status.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.lead_from = data.lead_from.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.products_and_services = data.products_and_services.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.client_profile = data.client_profile.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.contract_type = data.contract_type.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.office = data.office.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.users = data.users.map(x => ( {id: x.id, name: x.name}));
                this.selects.change_order_custom_fields = data.change_order_custom_fields;
            });
        },
        fetchCompanies() {
            axios.get(route('api.company.list-for-report')).then(({data}) => {
                this.companies = data;
            });
        },

        // onSelectCompany(company) {
        //     this.advanced_filter.companies_id.push(company.id);
        // },
        // onRemoveCompany(company) {
        //     this.advanced_filter.companies_id = this.advanced_filter.companies_id.filter((aux) => aux !== company.id)
        // },
        //Client Filter
        asyncFind(querry) {
            this.isLoading = true
            axios.get(route('api.company.filter-for-report', {querry}
            )).then(({data}) => {
                this.companies = data;
                this.isLoading = false
            }).catch((error) => {
                this.isLoading = false
                console.log('error', error);
            });
        },
        clear() {
            localStorage.setItem('last_search', '');

            this.$refs.customFields.clearFields();
            this.$refs.RecordDetailCustomFields.clearFields();
            this.customFieldsLocalStorage = null;
            this.checkChangeOrder();
            for (var item in this.advanced_filter) {
                if (Object.prototype.hasOwnProperty.call(this.advanced_filter, item)) {
                    if (item == 'advanced') {
                        this.advanced_filter[item] = true;
                        continue;
                    }

                    if (item.includes('_id') && item != 'project_id' && item != 'companies_id' && item != 'contact_ids' && item != 'legacy_id') {
                        this.advanced_filter[item] = 0;
                        continue;
                    }

                    if (item.includes('date') || item == 'pre_bid') {
                        this.advanced_filter[item] = {start: '', end: ''};
                        continue;
                    }
                    if (item == 'change_order_sales_statuses') {
                        this.advanced_filter[item] = null;
                        continue;
                    }

                    if(item === 'sales_behavior') {
                        this.advanced_filter.sales_behavior = _.each(this.advanced_filter.sales_behavior, function(obj) {
                            obj.start = "";
                            obj.end = "";
                        });
                    }

                    if(item === 'change_order_custom_fields') {
                        this.advanced_filter[item] = {};
                        continue;
                    }

                    if(item !== 'sales_behavior') {
                        this.advanced_filter[item] = '';
                    }
                }
            }
        },

        openNewViewModel() {
            this.new_view = (this.editableProjectView && this.editableProjectView.id) ? this.editableProjectView.name : '';
            $("#NewView").modal("show");
        },

        saveEditView() {
            if(this.new_view.replace(/\s/g, '') === ''){
                this.showError = 'Name field is required'
                return
            }
            this.showError = ''
            const customFields = this.$refs.customFields.getFields();
            const recordDetailCustomFields = this.$refs.RecordDetailCustomFields.getFields();
            localStorage.setItem('last_search', JSON.stringify({...this.advanced_filter, custom_fields: customFields, record_detail_custom_fields: recordDetailCustomFields}));
            this.$emit('saveNewView', {...this.advanced_filter, custom_fields: customFields, record_detail_custom_fields: recordDetailCustomFields, new_view:this.new_view});
            $('#NewView').modal('hide');
            this.new_view = '';
        },

        selectedCompanies() {
            const self = this;
            self.advanced_filter.contact_ids = [];
            self.contacts_data_loading = true;

            let selectedCompanies = self.advanced_filter.companies_id;
            let selectedCompanyIds = [];

            selectedCompanies.forEach(async (company) => {
                selectedCompanyIds.push(company.id);
            });

            if(selectedCompanyIds.length > 0) {
                axios.get(route('api.company.fetch-company-contacts', {company_ids: selectedCompanyIds})).then(({data}) => {
                    self.contacts = data;
                    self.contacts_data_loading = false;
                }).catch((error) => {
                    self.contacts_data_loading = false;
                    console.error('error', error);
                });
            } else {
                self.contacts_data_loading = false;
            }
        },
        resetAdvancedFilter() {
            this.advanced_filter = {
                advanced: true,
                project_id: '',
                legacy_id: '',
                project_name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_cell: '',
                contact_fax: '',
                sales_status_id: 0,
                marketing_status_id: 0,
                pre_bid: {start: '', end: ''},
                bid_date: {start: '', end: ''},
                lead_from_id: 0,
                estimator_id: 0,
                account_manager_id: 0,
                take_off_person_id: 0,
                products_and_services_id: 0,
                client_profile_id: 0,
                contract_type_id: 0,
                office_id: 0,
                relate_and_connect_id: 0,
                rules_of_engagement_id: 0,
                find_problems_id: 0,
                money_step_id: 0,
                decision_process_id: 0,
                base_bid: '',
                contract_amount: '',
                estimated_contract_date:{start:'',end:''},
                contract_date: {start: '', end: ''},
                login_date: {start: '', end: ''},
                gross_margin: '',
                labor_hours: '',
                dead_date: {start: '', end: ''},
                companies_id: [],
                contact_ids: [],
                comment: '',
                sales_statuses: null,
                marketing_statuses: null,
                lead_froms: null,
                estimators: null,
                account_managers: null,
                take_off_persons: null,
                products_and_services: null,
                client_profiles: null,
                contract_types: null,
                offices: null,
                change_order_name: '',
                change_order_sales_statuses: null,
                change_order_base_bid: '',
                change_order_contract_amount: '',
                change_order_bid_date: {start: '', end: ''},
                change_order_contract_date: {start: '', end: ''},
                change_order_gross_margin: '',
                attachment: '',
                change_order_custom_fields: {},
            };
            this.updateAdvancedFilter(this.salesBehaviors);
        },
        checkChangeOrder() {
            if(localStorage.getItem('change_order_advance_clear') === 'true')
            {
                localStorage.removeItem('change_order_advance_clear');
                this.advanced_filter.change_order_name = '';
                this.advanced_filter.change_order_sales_statuses = null;
                this.advanced_filter.change_order_base_bid = '';
                this.advanced_filter.change_order_contract_amount = '';
                this.advanced_filter.change_order_bid_date.start = '';
                this.advanced_filter.change_order_bid_date.end = '';
                this.advanced_filter.change_order_contract_date.start = '';
                this.advanced_filter.change_order_contract_date.end = '';
                this.advanced_filter.change_order_gross_margin = '';
            }
            if (
                this.advanced_filter.change_order_name !== '' ||
                this.advanced_filter.change_order_sales_statuses !== null ||
                this.advanced_filter.change_order_base_bid !== '' ||
                this.advanced_filter.change_order_contract_amount !== '' ||
                this.getSafe(() => this.advanced_filter.change_order_bid_date.start) !== '' ||
                this.getSafe(() => this.advanced_filter.change_order_bid_date.end) !== '' ||
                this.getSafe(() => this.advanced_filter.change_order_contract_date.start) !== '' ||
                this.getSafe(() => this.advanced_filter.change_order_contract_date.end) !== '' ||
                this.advanced_filter.change_order_gross_margin !== ''
            ) {
                localStorage.setItem('change_order_advance', 'true');

            } else {
                localStorage.setItem('change_order_advance', 'false');
            }
        },
        updateAdvancedFilter(newValues) {
            console.log("update advance filter new value", newValues);

            // 1. Normalize into an Array:
            const behaviors = Array.isArray(newValues)
                ? newValues
                : Object.values(newValues || {});

            // 2. Grab any existing sales_behavior map (or empty {})
            const existingMap =
                this.advancedSearchViewFilterProjectData?.sales_behavior || {};

            // 3. Build a fresh map: { [key]: { id, start, end } }
            const sales_behaviors_keys = behaviors.reduce((map, sb) => {
                const k = sb.key;
                const e = existingMap[k] || {};
                map[k] = {
                    id:    sb.id,
                    start: e.start || "",
                    end:   e.end   || ""
                };
                return map;
            }, {});

            // 4. Merge back into advanced_filter
            this.advanced_filter = {
                ...this.advanced_filter,
                sales_behavior: sales_behaviors_keys
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    height: calc(1em + .75rem + 2px);
    padding: 0;
}

.vdp-datepicker {
    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
    }
}

.form-control:disabled,
.form-control[readonly] {
    background-color: white !important;
}
.scrollable-div {
    max-height: 46rem;
    overflow-y: auto;
}
.multiselect .multiselect__placeholder {
    padding-top: 0 !important;
}
.multiselect .multiselect__tags {
    min-height: 32px !important;
}
</style>
